export default __webpack_public_path__ + "static/164-88106606932d139b9a010cb415304fc6.jpg";